import { useFormContext } from "react-hook-form"

import { InputElement } from "@front-shared/elements/input.element"

import {
    ICoverageOverrideFormData,
    IOverrideDefaultData,
} from "../../../types/data.types"

export const InlinedOverrideFormTPANameComponent: React.FunctionComponent<
    IInlinedOverrideFormTPANameComponentProps
> = props => {
    const {
        control,
        formState: { errors },
    } = useFormContext()

    return (
        <InputElement
            className="w-[290px]"
            name={props.fieldDataKey}
            size="small"
            reactHookErrors={errors}
            reactHookControl={control}
            reactHookValidations={{
                validate: {
                    conditionalRequire: (
                        _: boolean,
                        values: ICoverageOverrideFormData,
                    ) => {
                        return !!values.thirdPartyAdministratorType &&
                            !values.thirdPartyAdministratorName
                            ? "Name is required when Type is set"
                            : true
                    },
                },
            }}
            defaultValue={props.defaultData.form[props.fieldDataKey]}
            disabled={props.isDisabled}
            placeholder={props.mixedValuesPlaceholder}
        />
    )
}

interface IInlinedOverrideFormTPANameComponentProps {
    defaultData: IOverrideDefaultData
    fieldDataKey: keyof ICoverageOverrideFormData
    isDisabled?: boolean
    mixedValuesPlaceholder?: string
}
